import { Status } from 'custom-studio-constants';
import { RiCheckboxCircleFill } from 'react-icons/ri';

export default function StatusIcon({ size = 24, status = Status.Disabled, className = '' }) {
	const statusClassName = status.toLowerCase();
	return <RiCheckboxCircleFill className={`status-icon ${statusClassName} ${className}`} size={size} />;
}
